import { InjectionToken, Provider } from '@angular/core';
import { CartModificationPayload, CustomCart, ShareCartPayload } from '@cart/const';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AuthActions, Cart, StateUtils } from '@spartacus/core';
import { CLONE_CART_ENTITY, CustomCartState, DIFFS, ORGANIZATION_ON_CART, SHARE_CART_ENTITY } from '../cart-state';
import { MULTI_CART_DATA, MultiCartState } from '../multi-cart-state';
import { activeCartReducer, cartEntitiesReducer } from './multi-cart.reducer';
import { reducer as temporaryCartIdReducer } from './temp-cart-id.reducer';
import { voucherErrorReducer } from './voucher-error.reducer';

export function clearMultiCartState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === AuthActions.LOGOUT) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const multiCartMetaReducers: MetaReducer<any>[] = [clearMultiCartState];

export type CartReducers = CustomCartState;

export function getReducers(): ActionReducerMap<CartReducers> {
  return {
    cartDiff: StateUtils.loaderReducer<CartModificationPayload>(DIFFS),
    shareCart: StateUtils.loaderReducer<ShareCartPayload>(SHARE_CART_ENTITY),
    cloneCart: StateUtils.loaderReducer<Cart>(CLONE_CART_ENTITY),
    organizationToCart: StateUtils.loaderReducer<CustomCart>(ORGANIZATION_ON_CART),
    tempCartId: temporaryCartIdReducer,
    voucherError: voucherErrorReducer,
  };
}

export function getMultiCartReducers(): ActionReducerMap<MultiCartState> {
  return {
    carts: StateUtils.entityProcessesLoaderReducer<Cart>(MULTI_CART_DATA, cartEntitiesReducer),
    active: activeCartReducer,
  };
}

export const multiCartReducerToken: InjectionToken<ActionReducerMap<MultiCartState>> = new InjectionToken<
  ActionReducerMap<MultiCartState>
>('MultiCartReducers');

export const reducerToken: InjectionToken<ActionReducerMap<CartReducers>> = new InjectionToken<
  ActionReducerMap<CartReducers>
>('CartReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export const multiCartReducerProvider: Provider = {
  provide: multiCartReducerToken,
  useFactory: getMultiCartReducers,
};
